export const types = {
    REQUEST_GET_ACTIVE_COUNTRY_LIST: "comex/REQUEST_GET_ACTIVE_COUNTRY_LIST",
    SUCCESS_GET_ACTIVE_COUNTRY_LIST: "comex/SUCCESS_GET_ACTIVE_COUNTRY_LIST",
    FAILURE_GET_ACTIVE_COUNTRY_LIST: "comex/FAILURE_GET_ACTIVE_COUNTRY_LIST",

    REQUEST_GET_COMEX_SELECTORS: "comex/REQUEST_GET_COMEX_SELECTORS",
    SUCCESS_GET_COMEX_SELECTORS: "comex/SUCCESS_GET_COMEX_SELECTORS",
    FAILURE_GET_COMEX_SELECTORS: "comex/FAILURE_GET_COMEX_SELECTORS",

    SET_COMEX_CONTACT: "comex/SET_COMEX_CONTACT",
    CLEAN_COMEX_CONTACT_LIST: "comex/CLEAN_COMEX_CONTACT_LIST",
    SET_COMEX_DOCUMENT: "comex/SET_COMEX_DOCUMENT",
    SET_COMEX_GOODS_DOCUMENT: "comex/SET_COMEX_GOODS_DOCUMENT",
    SET_COMEX_TRANSFER: "comex/SET_COMEX_TRANSFER",
    SET_NEW_COMEX_TRANSFER: "comex/SET_NEW_COMEX_TRANSFER",

    CREATE_COMEX_TRANSFER_STEP3_REQUEST: "comex/CREATE_COMEX_TRANSFER_STEP3_REQUEST",
    CREATE_COMEX_TRANSFER_STEP3_SUCCESS: "comex/CREATE_COMEX_TRANSFER_STEP3_SUCCESS",
    CREATE_COMEX_TRANSFER_STEP3_FAILURE: "comex/CREATE_COMEX_TRANSFER_STEP3_FAILURE",

    CREATE_COMEX_CONTACT_REQUEST: "comex/CREATE_COMEX_CONTACT_REQUEST",
    CREATE_COMEX_CONTACT_SUCCESS: "comex/CREATE_COMEX_CONTACT_SUCCESS",
    CREATE_COMEX_CONTACT_FAILURE: "comex/CREATE_COMEX_CONTACT_FAILURE",

    GET_COMEX_CONTACT_LIST_REQUEST: "comex/GET_COMEX_CONTACT_LIST_REQUEST",
    GET_COMEX_CONTACT_LIST_SUCCESS: "comex/GET_COMEX_CONTACT_LIST_SUCCESS",
    GET_COMEX_CONTACT_LIST_FAILURE: "comex/GET_COMEX_CONTACT_LIST_FAILURE",

    MODIFY_COMEX_CONTACT_PRE_REQUEST: "comex/MODIFY_COMEX_CONTACT_PRE_REQUEST",
    MODIFY_COMEX_CONTACT_PRE_SUCCESS: "comex/MODIFY_COMEX_CONTACT_PRE_SUCCESS",
    MODIFY_COMEX_CONTACT_PRE_FAILURE: "comex/MODIFY_COMEX_CONTACT_PRE_FAILURE",

    MODIFY_COMEX_CONTACT_REQUEST: "comex/MODIFY_COMEX_CONTACT_REQUEST",
    MODIFY_COMEX_CONTACT_SUCCESS: "comex/MODIFY_COMEX_CONTACT_SUCCESS",
    MODIFY_COMEX_CONTACT_FAILURE: "comex/MODIFY_COMEX_CONTACT_FAILURE",

    DELETE_COMEX_CONTACT_REQUEST: "comex/DELETE_COMEX_CONTACT_REQUEST",
    DELETE_COMEX_CONTACT_SUCCESS: "comex/DELETE_COMEX_CONTACT_SUCCESS",
    DELETE_COMEX_CONTACT_FAILURE: "comex/DELETE_COMEX_CONTACT_FAILURE",

    DOCUMENT_UPLOAD_REQUEST: "comex/DOCUMENT_UPLOAD_REQUEST",
    DOCUMENT_UPLOAD_SUCCESS: "comex/ DOCUMENT_UPLOAD_SUCCESS",
    DOCUMENT_UPLOAD_FAILURE: "comex/ DOCUMENT_UPLOAD_FAILURE",
    DOCUMENT_UPLOAD_RESET: "comex/DOCUMENT_UPLOAD_RESET",

    GENERATE_TRANSFER_REQUEST: "comex/GENERATE_TRANSFER_REQUEST",
    GENERATE_TRANSFER_SUCCESS: "comex/GENERATE_TRANSFER_SUCCESS",
    GENERATE_TRANSFER_FAILURE: "comex/GENERATE_TRANSFER_FAILURE",

    ADD_UPLOADED_DOCUMENT: "comex/ADD_UPLOADED_DOCUMENT",

    DOCUMENT_DELETE_REQUEST: "comex/DOCUMENT_DELETE_REQUEST",
    DOCUMENT_DELETE_SUCCESS: "comex/DOCUMENT_DELETE_SUCCESS",
    DOCUMENT_DELETE_FAILURE: "comex/DOCUMENT_DELETE_FAILURE",

    DOCUMENT_DOWNLOAD_REQUEST: "comex/DOCUMENT_DOWNLOAD_REQUEST",
    DOCUMENT_DOWNLOAD_SUCCESS: "comex/DOCUMENT_DOWNLOAD_SUCCESS",
    DOCUMENT_DOWNLOAD_FAILURE: "comex/DOCUMENT_DOWNLOAD_FAILURE",

    GET_TRANSACTIONS_LIST_REQUEST: "comex/GET_TRANSACTIONS_LIST_REQUEST",
    GET_TRANSACTIONS_LIST_SUCCESS: "comex/GET_TRANSACTIONS_LIST_SUCCESS",
    GET_TRANSACTIONS_LIST_FAILURE: "comex/GET_TRANSACTIONS_LIST_FAILURE",

    GET_DRAFT_TRANSACTIONS_LIST_REQUEST: "comex/GET_DRAFT_TRANSACTIONS_LIST_REQUEST",
    GET_DRAFT_TRANSACTIONS_LIST_SUCCESS: "comex/GET_DRAFT_TRANSACTIONS_LIST_SUCCESS",
    GET_DRAFT_TRANSACTIONS_LIST_FAILURE: "comex/GET_DRAFT_TRANSACTIONS_LIST_FAILURE",

    SET_COMEX_DATA_FOR_RESUMING: "comex/SET_COMEX_DATA_FOR_RESUMING",

    GET_FINISHED_TRANSACTIONS_LIST_REQUEST: "comex/GET_FINISHED_TRANSACTIONS_LIST_REQUEST",
    GET_FINISHED_TRANSACTIONS_LIST_SUCCESS: "comex/GET_FINISHED_TRANSACTIONS_LIST_SUCCESS",
    GET_FINISHED_TRANSACTIONS_LIST_FAILURE: "comex/GET_FINISHED_TRANSACTIONS_LIST_FAILURE",

    SEND_TRANSACTION_TICKET_REQUEST: "comex/SEND_TRANSACTION_TICKET_REQUEST",
    SEND_TRANSACTION_TICKET_FAILURE: "comex/SEND_TRANSACTION_TICKET_FAILURE",
    SEND_TRANSACTION_TICKET_SUCCESS: "comex/SEND_TRANSACTION_TICKET_SUCCESS",
};

export const INITIAL_STATE = {
    comexId: "",
    comexContactList: [],
    comexContact: {},
    comexTransfer: {},
    comexCurrencies: [],
    comexCountries: [],
    countryList: [],
    uploadedDocuments: [],
    fetching: false,
    moreDestinations: false,
    pageNumber: 1,
    fetchingDelete: false,
    comexDocumentation: null,
    documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null },
    comexGoodsDocumentation: null,
    transactionsList: [],
    draftTransactionsList: [],
    finishedTransactionsList: [],
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        comexContactList,
        moreStatements,
        pageNumber,
        totalPages,
        comexContact,
        documentToUploadRequest,
        documentCode,
        transactionsList,
        draftTransactionsList,
        comexTransfer,
        comexId,
        goodsDocumentation,
        comexDocumentation,
        finishedTransactionsList,
    } = action;
    switch (action.type) {
        case types.REQUEST_GET_ACTIVE_COUNTRY_LIST:
            return {
                ...state,
                fetching: true,
            };

        case types.SUCCESS_GET_ACTIVE_COUNTRY_LIST:
            return {
                ...state,
                countryList: action.countryList.reduce(
                    (newList, { name }) => [...newList, { value: name, label: name }],
                    [],
                ),
                fetching: false,
            };

        case types.FAILURE_GET_ACTIVE_COUNTRY_LIST:
            return {
                ...state,
                fetching: false,
            };
        case types.REQUEST_GET_COMEX_SELECTORS:
            return {
                ...state,
                fetching: true,
            };

        case types.SUCCESS_GET_COMEX_SELECTORS:
            return {
                ...state,
                comexCurrencies: action.currencies,
                comexCountries: action.countries,
                fetching: false,
            };

        case types.FAILURE_GET_COMEX_SELECTORS:
            return {
                ...state,
                fetching: false,
            };

        case types.SET_COMEX_CONTACT:
            return {
                ...state,
                comexContact: action.comexContact,
            };
        case types.SET_COMEX_TRANSFER:
            return {
                ...state,
                comexTransfer: action.comexTransfer,
            };

        case types.SET_NEW_COMEX_TRANSFER:
            return {
                ...state,
                comexTransfer: {},
                comexDocumentation: {},
                comexId: null,
            };

        case types.CREATE_COMEX_TRANSFER_STEP3_REQUEST:
            return {
                ...state,
                fetching: false,
            };

        case types.CREATE_COMEX_TRANSFER_STEP3_SUCCESS:
            return {
                ...state,
                fetching: false,
                comexId: action.comexId,
            };
        case types.CREATE_COMEX_TRANSFER_STEP3_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.CREATE_COMEX_CONTACT_REQUEST:
            return {
                ...state,
                fetching: false,
            };

        case types.CREATE_COMEX_CONTACT_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.CREATE_COMEX_CONTACT_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.CLEAN_COMEX_CONTACT_LIST:
            return { ...state, comexContactList: [] };

        case types.GET_COMEX_CONTACT_LIST_REQUEST:
            return {
                ...state,
                fetching: true,
            };

        case types.GET_COMEX_CONTACT_LIST_SUCCESS:
            return {
                ...state,
                comexContactList,
                moreDestinations: moreStatements,
                fetching: false,
                pageNumber,
                totalPages,
            };
        case types.GET_COMEX_CONTACT_LIST_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.MODIFY_COMEX_CONTACT_PRE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.MODIFY_COMEX_CONTACT_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                comexContact,
            };
        case types.MODIFY_COMEX_CONTACT_PRE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.MODIFY_COMEX_CONTACT_REQUEST:
            return {
                ...state,
                fetching: false,
            };
        case types.MODIFY_COMEX_CONTACT_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.MODIFY_COMEX_CONTACT_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.DELETE_COMEX_CONTACT_REQUEST:
            return {
                ...state,
                fetchingDelete: true,
            };
        case types.DELETE_COMEX_CONTACT_SUCCESS:
            return {
                ...state,
                fetchingDelete: false,
            };
        case types.DELETE_COMEX_CONTACT_FAILURE:
            return {
                ...state,
                fetchingDelete: false,
            };
        case types.SET_COMEX_DOCUMENT:
            return {
                ...state,
                comexDocumentation: action.comexDocumentation,
            };
        case types.SET_COMEX_GOODS_DOCUMENT:
            return {
                ...state,
                comexGoodsDocumentation: action.comexGoodsDocumentation,
            };
        case types.DOCUMENT_UPLOAD_REQUEST:
            return {
                ...state,
                documentToUploadRequest: { status: "FETCHING", value: "", error: null, id: documentCode },
            };
        case types.DOCUMENT_UPLOAD_SUCCESS:
            return {
                ...state,
                documentToUploadRequest: {
                    status: "SUCCESS",
                    value: documentToUploadRequest,
                    error: null,
                    id: documentCode,
                },
            };
        case types.DOCUMENT_UPLOAD_FAILURE:
            return {
                ...state,
                documentToUploadRequest: {
                    status: "FAILURE",
                    value: "",
                    error: documentToUploadRequest,
                    id: documentCode,
                },
            };
        case types.DOCUMENT_UPLOAD_RESET:
            return {
                ...state,
                documentToUploadRequest: { status: "INITIAL", value: "", error: null, id: null },
            };

        case types.ADD_UPLOADED_DOCUMENT:
            return {
                ...state,
                uploadedDocuments: [...state.uploadedDocuments, action.document],
                documentToUploadRequest: {
                    status: "SUCCESS",
                    id: action.document?.documentCode,
                    value: documentToUploadRequest,
                    error: null,
                },
            };
        case types.GENERATE_TRANSFER_REQUEST:
            return {
                ...state,
                fetching: true,
            };

        case types.GENERATE_TRANSFER_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.GENERATE_TRANSFER_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.DOCUMENT_DELETE_REQUEST:
            return {
                ...state,
            };
        case types.DOCUMENT_DOWNLOAD_REQUEST:
            return {
                ...state,
            };
        case types.GET_TRANSACTIONS_LIST_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GET_TRANSACTIONS_LIST_SUCCESS:
            return {
                ...state,
                fetching: false,
                transactionsList,
            };
        case types.GET_TRANSACTIONS_LIST_FAILURE:
            return {
                ...state,
                fetching: false,
                transactionsList: null,
            }; 
        case types.GET_DRAFT_TRANSACTIONS_LIST_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GET_DRAFT_TRANSACTIONS_LIST_SUCCESS:
            return {
                ...state,
                fetching: false,
                draftTransactionsList,
            };
        case types.GET_DRAFT_TRANSACTIONS_LIST_FAILURE:
            return {
                ...state,
                fetching: false,
                draftTransactionsList: null,
            }; 
        case types.SET_COMEX_DATA_FOR_RESUMING:
            return {
                ...state,
                comexTransfer,
                comexId,
                comexGoodsDocumentation: goodsDocumentation,
                comexDocumentation: comexDocumentation,
            };
        case types.GET_FINISHED_TRANSACTIONS_LIST_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GET_FINISHED_TRANSACTIONS_LIST_SUCCESS:
            return {
                ...state,
                fetching: false,
                finishedTransactionsList,
            };
        case types.GET_FINISHED_TRANSACTIONS_LIST_FAILURE:
            return {
                ...state,
                fetching: false,
                finishedTransactionsList: null,
            };
        case types.SEND_TRANSACTION_TICKET_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.SEND_TRANSACTION_TICKET_SUCCESS:
            return {
                ...state,
                fetching: false,
                transactionTicket: null,
            };
        case types.SEND_TRANSACTION_TICKET_FAILURE:
            return {
                ...state,
                fetching: false,
            };                                                        
        default:
            return state;
    }
};

export const actions = {
    createComexContact: (comexContact, formikBag, credentialType) => ({
        type: types.CREATE_COMEX_CONTACT_REQUEST,
        comexContact,
        formikBag,
        credentialType,
    }),

    getActiveCountryList: () => ({
        type: types.REQUEST_GET_ACTIVE_COUNTRY_LIST,
    }),

    getComexSelectors: () => ({
        type: types.REQUEST_GET_COMEX_SELECTORS,
    }),

    setComexContact: (comexContact) => ({
        type: types.SET_COMEX_CONTACT,
        comexContact,
    }),

    cleanComexContactList: () => ({
        type: types.CLEAN_COMEX_CONTACT_LIST,
    }),

    getComexContactList: (filters, pageNo) => ({
        type: types.GET_COMEX_CONTACT_LIST_REQUEST,
        filters,
        pageNo,
    }),

    modifyComexContactPre: (idContactDestination) => ({
        type: types.MODIFY_COMEX_CONTACT_PRE_REQUEST,
        idContactDestination,
    }),

    modifyComexContact: (comexContact, formikBag, credentialType) => ({
        type: types.MODIFY_COMEX_CONTACT_REQUEST,
        comexContact,
        formikBag,
        credentialType,
    }),

    deleteComexContact: (params) => ({
        type: types.DELETE_COMEX_CONTACT_REQUEST,
        params,
    }),

    setComexDocument: (comexDocumentation) => ({
        type: types.SET_COMEX_DOCUMENT,
        comexDocumentation,
    }),

    setComexGoodsDocument: (comexGoodsDocumentation) => ({
        type: types.SET_COMEX_GOODS_DOCUMENT,
        comexGoodsDocumentation,
    }),

    setComexTransfer: (comexTransfer) => ({
        type: types.SET_COMEX_TRANSFER,
        comexTransfer,
    }),

    setNewComexTransfer: () => ({
        type: types.SET_NEW_COMEX_TRANSFER,
    }),

    createComexTransfer: (comexTransfer, formikBag, credentialType) => ({
        type: types.CREATE_COMEX_TRANSFER_STEP3_REQUEST,
        comexTransfer,
        formikBag,
        credentialType,
    }),

    documentUpload: (documentToUpload) => ({
        type: types.DOCUMENT_UPLOAD_REQUEST,
        documentToUpload,
        documentCode: documentToUpload.uploaderRequestId,
    }),

    documentDelete: (documentId) => ({
        type: types.DOCUMENT_DELETE_REQUEST,
        documentId,
    }),

    documentDownload: (comexId, documentCode) => ({
        type: types.DOCUMENT_DOWNLOAD_REQUEST,
        comexId,
        documentCode,
    }),

    resetDocumentToUploadRequest: () => ({
        type: types.DOCUMENT_UPLOAD_RESET,
    }),

    addUploadedDocument: (document) => ({
        type: types.ADD_UPLOADED_DOCUMENT,
        document,
    }),

    generateTrasnsfer: (comexTransfer, formikBag, credentialType) => ({
        type: types.GENERATE_TRANSFER_REQUEST,
        comexTransfer,
        formikBag,
        credentialType,
    }),

    getTransactionsListRequest: (params) => ({
        type: types.GET_TRANSACTIONS_LIST_REQUEST,
        params,
    }),

    getDraftTransactionsListRequest: (params) => ({
        type: types.GET_DRAFT_TRANSACTIONS_LIST_REQUEST,
        params,
    }),

    getFinishedTransactionsListRequest: (params) => ({
        type: types.GET_FINISHED_TRANSACTIONS_LIST_REQUEST,
        params,
    }),

    setComexDataForContinue: (comexTransfer, comexId, goodsDocumentation, comexDocumentation) => ({
        type: types.SET_COMEX_DATA_FOR_RESUMING,
        comexTransfer,
        comexId,
        goodsDocumentation,
        comexDocumentation,
    }),
    
    sendTransactionTicket: (request) => ({
        type: types.SEND_TRANSACTION_TICKET_REQUEST,
        request,
    }),
};

export const selectors = {
    getCountryList: ({ comex }) => comex.countryList,
    getFetching: ({ comex }) => comex.fetching,
    getTransactionsList: ({ comex }) => comex.transactionsList,
    getDraftTransactionsList: ({ comex }) => comex.draftTransactionsList,
    getFinishedTransactionsList: ({ comex }) => comex.finishedTransactionsList,
};
